import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  split,
} from '@apollo/client';

import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';

const JULEB_DOMAIN = window.location.host;

const GRAPHQL_SERVICE =
  process.env.REACT_APP_GRAPHQL_SERVICE || 'support_graphql';
export const endpoint =
  process.env.REACT_APP_GRAPHQL_ENDPOINT ||
  `${
    JULEB_DOMAIN.includes('localhost') ? 'http' : 'https'
  }://${JULEB_DOMAIN}/${GRAPHQL_SERVICE}`;

const wsEndpoint =
  process.env.REACT_APP_GRAPHQL_WS_ENDPOINT ||
  `wss://${JULEB_DOMAIN}/${GRAPHQL_SERVICE}`;

function createWSLink(sessionId: string, database) {
  return new WebSocketLink({
    uri: `${wsEndpoint}/graphql`,
    options: {
      reconnect: true,
      connectionParams: async () => {
        return {
          headers: {
            'x-cookie': `${document.cookie};session_id=${sessionId};`,
            'x-database': database,
          },
        };
      },
    },
  });
}
function createGraphQLHttpLink(sessionId: string, db: string) {
  if (!sessionId) {
    sessionId = localStorage.getItem('session') || '';
  }
  return createHttpLink({
    uri: `${endpoint}/graphql`,
    headers: {
      'x-cookie': `${document.cookie};session_id=${sessionId};`,
      'x-database': db,
    },
  });
}

export function createApolloClient(sessionId: string, db: string) {
  const tempSession = sessionId;
  const link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    createWSLink(tempSession, db),
    createGraphQLHttpLink(tempSession, db),
    // createGraphQLUploadLink(sessionId)
  );

  return new ApolloClient({
    link,
    credentials: 'include',
    cache: new InMemoryCache(),
  });
}
